import React, { useState, useRef, useEffect, useCallback } from 'react';

export function InfoTooltip({ text }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const [above, setAbove] = useState(false);

  const reposition = useCallback(() => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    setAbove(rect.bottom + 160 > window.innerHeight);
  }, []);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [open]);

  return (
    <span
      className="info-tip"
      ref={ref}
      onMouseEnter={() => { reposition(); setOpen(true); }}
      onMouseLeave={() => setOpen(false)}
      onClick={(e) => { e.stopPropagation(); reposition(); setOpen(o => !o); }}
    >
      <span className="info-tip-trigger" aria-label="More information">?</span>
      {open && (
        <div className={`info-tip-card ${above ? 'info-tip-above' : ''}`}>
          <div className={`info-tip-caret ${above ? 'info-tip-caret-below' : ''}`} />
          {text}
        </div>
      )}
    </span>
  );
}
